import { FileSearch2, Upload, X } from '@/components/icons'
import { Button } from './ui/button'
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from './ui/drawer'

interface TripAddDocumentDrawerProps {
  isOpen: boolean
  onClose: () => void
  onSelectDocuments: () => void
  onSelectUpload: () => void
}

export function TripAddDocumentDrawer({
  isOpen,
  onClose,
  onSelectDocuments,
  onSelectUpload,
}: TripAddDocumentDrawerProps) {
  return (
    <Drawer open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DrawerContent className="bg-surface-L0 rounded-tl-2xl rounded-tr-2xl shadow-lg">
        <DrawerHeader className="flex items-center justify-between p-4">
          <DrawerTitle className="text-lg font-semibold text-content-primary-bold">
            Add Documents
          </DrawerTitle>
          <Button variant="secondary" size="icon" roundness="round" className="size-8" onClick={onClose}>
            <X className="w-4 h-4" />
          </Button>
        </DrawerHeader>

        <div className="flex flex-col px-4 pb-8">
          <button
            onClick={() => {
              onClose()
              onSelectDocuments()
            }}
            className="flex items-center gap-3 px-2 py-4 active:bg-surface-L2 transition-colors rounded-lg"
          >
            <FileSearch2 className="size-5 text-content-primary-bold shrink-0" />
            <span className="text-sm font-medium text-content-primary-bold">Documents</span>
          </button>

          <div className="border-t border-border-L2" />

          <button
            onClick={() => {
              onClose()
              onSelectUpload()
            }}
            className="flex items-center gap-3 px-2 py-4 active:bg-surface-L2 transition-colors rounded-lg"
          >
            <Upload className="size-5 text-content-primary-bold shrink-0" />
            <span className="text-sm font-medium text-content-primary-bold">Upload</span>
          </button>
        </div>
      </DrawerContent>
    </Drawer>
  )
}
